<PublicEntityCard
  class="public-tournament-card"
  :class="cardClass"
  :to="to"
  :title="title"
  :subtitle="subtitle"
  :background-image="backgroundImage"
  :image-mode="imageMode"
  :scroll-card="scrollCard"
  :accent-type="systemType"
>
  <template #badges>
    <span
      v-if="badge && badgeTooltip"
      class="public-tournament-card__badge public-date-badge"
      :class="badgeClass"
      v-tooltip.bottom="{ value: badgeTooltip, class: 'tt-sm' }"
    >
      {{ badge }}
    </span>
    <span
      v-else-if="badge"
      class="public-tournament-card__badge public-date-badge"
      :class="badgeClass"
    >
      {{ badge }}
    </span>
    <span v-if="timeBadge" class="public-tournament-card__time-badge public-date-badge">
      <i class="bi bi-clock"></i>{{ timeBadge }}
    </span>
    <span
      v-if="status"
      class="public-tournament-card__status public-status-badge"
      :class="status.className"
    >
      <i v-if="status.icon" :class="status.icon"></i>
      {{ status.label }}
    </span>
    <span v-if="placeName && placeUnderBadges" class="public-tournament-card__place"><i class="bi bi-geo-alt"></i>{{ placeName }}</span>
  </template>

  <template #top-right>
    <div v-if="systemLabel || $slots['system-meta']" class="public-tournament-card__system-stack">
      <span
        v-if="systemLabel"
        class="public-tournament-card__system public-tournament-system-badge badge"
        :class="systemClass"
      >
        {{ systemLabel }}
      </span>
      <div v-if="$slots['system-meta']" class="public-tournament-card__system-meta">
        <slot name="system-meta" />
      </div>
    </div>
  </template>

  <template v-if="$slots.description" #description>
    <slot name="description" />
  </template>

  <template v-if="(placeName && !placeUnderBadges) || $slots.meta" #meta>
    <span v-if="placeName && !placeUnderBadges"><i class="bi bi-geo-alt"></i>{{ placeName }}</span>
    <slot name="meta" />
  </template>

  <template v-if="$slots.extra" #extra>
    <slot name="extra" />
  </template>

  <template v-if="$slots.actions" #actions>
    <slot name="actions" />
  </template>
</PublicEntityCard>
